<!-- Contenedor para mostrar notificaciones (toasts) -->
<app-toast-container/>

<!-- Punto de inserción para las vistas cargadas por el enrutador -->
<router-outlet/>

<!-- Componente global para mostrar un indicador de carga (spinner) -->
<app-spinner/>

<!-- Componente para mostrar el modal de inactividad -->
<app-inactivity-modal/>